module.exports = __webpack_public_path__ + "img/frame_freelance.a76e9985.jpg";